import React from 'react'

const PartnerSection = ({ benefits, partnerForm, onPartnerFormChange, onPartnerFormSubmit }) => (
  <section className='partner-section' id='partner'>
    <div className='landing-shell partner-section__inner'>
      <div className='partner-section__heading'>
        <p className='section-label'>Work with us</p>
        <h2 className='section-title section-title--dark'>
          Be Our <em>Partner</em>
        </h2>
        <p>Great products? We connect you directly to communities ready to buy.</p>
      </div>

      <div className='partner-benefits landing-reveal'>
        {benefits.map((benefit) => (
          <article key={benefit.title} className='partner-benefit-card'>
            <div className='partner-benefit-card__icon'>{benefit.icon}</div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </article>
        ))}
      </div>

      <form className='partner-form landing-reveal' onSubmit={onPartnerFormSubmit}>
        <div className='partner-form__row'>
          <div className='partner-form__field'>
            <label htmlFor='partner-name'>Your name</label>
            <input
              id='partner-name'
              name='name'
              type='text'
              placeholder='Jane Tan'
              value={partnerForm.name}
              onChange={onPartnerFormChange}
              required
            />
          </div>
          <div className='partner-form__field'>
            <label htmlFor='partner-email'>Email address</label>
            <input
              id='partner-email'
              name='email'
              type='email'
              placeholder='jane@company.com'
              value={partnerForm.email}
              onChange={onPartnerFormChange}
              required
            />
          </div>
        </div>

        <div className='partner-form__field partner-form__field--full'>
          <label htmlFor='partner-message'>Tell us about your products</label>
          <textarea
            id='partner-message'
            name='message'
            rows={5}
            placeholder="I'd like to offer... Our products are... We'd love to reach communities in..."
            value={partnerForm.message}
            onChange={onPartnerFormChange}
            required
          />
        </div>

        <button type='submit' className='partner-form__submit'>
          Send message 🐝
        </button>
      </form>
    </div>
  </section>
)

export default PartnerSection
